import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import store from '../../store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ...store.state,

    frontConfig: {
      layout: {
        align: 'left'
      },

      timeline: {
        src: '',
        width: '',
        height: ''
      },

      home: {
        src: '',
        edit: ''
      },

      research: {
        src: '',
        edit: ''
      },

      tools: {
        src: '',
        edit: ''
      }
    }
  },

  mutations: {
    ...store.mutations,

    setFrontConfig (state, conf) {
      state.frontConfig = conf
    }
  },

  actions: {
    ...store.actions,

    updateFrontConfig ({commit, state, dispatch}, conf) {
      let parts = [new Blob([JSON.stringify(conf)], { type: 'application/json' })]
      let fileToSend = new File(parts, 'front-config.json', {
        type: 'application/json'
      })
      let formData = new FormData()
      formData.append('config', fileToSend)

      let oldConf = state.frontConfig
      commit('setFrontConfig', conf)

      axios({
        method: 'post',
        url: `${state.host}/dokhlab/actions/update_front_config`,
        data: formData,
        config: {headers: {'Content-Type': 'multipart/form-data'}},
        withCredentials: true
      }).then(response => {
      }).catch(error => {
        alert('Update website config failed!!!')
        commit('setFrontConfig', oldConf)
        console.log(error.response)
      })
    }
  },

  getters: {
    ...store.getters
  }
})

